import { Project } from 'components';
import styles from './projects.module.css';

export default function ProjectsSection() {
  const stacks = [
    <img src="stack1.png" alt="Stack 1" />,
    <img src="stack2.png" alt="Stack 1" />,
    <img src="stack3.png" alt="Stack 1" />,
  ];

  return (
    <section id="proyectos" className={styles.section}>
      <header>
        <h1>Proyectos</h1>
      </header>
      <div>
        <Project
          stack={stacks[0]}
          name="Books Library"
          color="#008AD7"
          src="books-library.png"
          alt="Books Library"
          available={false}
          url="https://github.com/fontseca/tropical-writing-editor"
        >
          Books Library es un programa muy sencillo de instalar y con el que se puede llevar el
          control de los préstamos de libros realizados por estudiantes y personal docente, de una
          manera inmediata. Este software fue creado para ser utilizado en cualquier centro escolar
          y universidades. La aplicación funciona de forma local sin ningún límite.
        </Project>
        <Project
          name="Tropical Writing Editor"
          color="#D200D7"
          stack={stacks[1]}
          src="tropical-writing-editor.png"
          alt="Tropical Writing Editor"
          available={false}
          url="https://github.com/fontseca/tropical-writing-editor"
        >
          Tropical Writing Editor es un editor de escritura fácil de utilizar con el cual pueden
          crearse novelas, cuentos, libros y otro tipo de obras literarias en un mimsmo lugar. El
          editor puede usarse de forma local, es decir desde la computadora del autor de la obra. Se
          pude crear una cantidad ilimitada de obras en las cuales es posible guardar ideas, frases
          o simples notas que lleguen a la mente del autor. Este editor puede ser utilizado por
          cualquier persona interesada por la escritura o profesionales como periodistas.
        </Project>
        <Project
          stack={stacks[2]}
          name="Omicron UNO"
          color="#CE4555"
          src="omicron-uno.png"
          alt="Omicron UNO"
          available={false}
        >
          El proyecto Omicron UNO consiste en un dispositivo de bajo costo hecho a base de Arduino
          que registra el ritmo cardiaco de una persona para realizar un electrocardiograma en
          cualquier momento del día. El dispositivo se conecta por medio de Bluetooth a una
          aplicación móvil donde se grafican y registran sus datos. Dichos datos se almacenan en la
          nube y se pueden almacenar en formato PDF. La aplicación guarda un historial de la
          frecuencia cardíaca de la persona. De esta manera se puede notar alguna variación en su
          ritmo natural. El historial de los estudios puede ser compartido con algún doctor, ya sea
          que este habite en el país o en otro lugar.
        </Project>
      </div>
      <div className={styles.lineXTop}></div>
      <div className={styles.lineY}></div>
      <div className={styles.lineXBottom}></div>
    </section>
  );
}
